/* Header search modal behaviour.
   Liquid-derived config (search route, predictive on/off) is read from data-*
   attributes on [data-search-modal] so this file can stay a static asset (no Liquid).
   Predictive results are rendered from the same standard search engine the /search
   page uses (Section Rendering API: section_id=predictive-results). */
(function () {
  var modal = document.querySelector('[data-search-modal]');
  if (!modal) return;

  var searchUrl = modal.getAttribute('data-search-url') || '/search';
  var predictive = modal.getAttribute('data-predictive') !== 'false';

  var overlay = document.querySelector('[data-search-overlay]');
  var openers = document.querySelectorAll('[data-search-open]');
  var closeBtn = modal.querySelector('[data-search-close]');
  var input = modal.querySelector('[data-search-input]');
  var clearBtn = modal.querySelector('[data-search-clear]');
  var resultsEl = modal.querySelector('[data-search-results]');

  var headerEl = document.querySelector('.header-wrapper');
  var lastFocus = null;
  var debounceTimer = null;
  var controller = null;
  var openTimer = null;
  var closeTimer = null;

  // Drop the panel (and dim) below the header so the header stays visible above it.
  // Setting --hs-top changes the (transitioned) hidden transform, so apply it with the
  // transition suppressed — otherwise the first open jerks as the panel re-positions.
  function positionBelowHeader() {
    var h = headerEl ? Math.round(headerEl.getBoundingClientRect().height) : 72;
    var prev = modal.style.transition;
    modal.style.transition = 'none';
    modal.style.setProperty('--hs-top', h + 'px');
    modal.style.maxHeight = 'calc(100dvh - ' + h + 'px)';
    if (overlay) overlay.style.top = h + 'px';
    void modal.offsetWidth; // flush the no-transition reposition before re-enabling
    modal.style.transition = prev;
  }

  // Pre-position on load so the very first open has no transform jump to animate.
  positionBelowHeader();

  function suggest(q) {
    if (controller) controller.abort();
    controller = new AbortController();
    resultsEl.innerHTML = '<p class="header-search__searching">Searching&hellip;</p>';
    var url = searchUrl + '?q=' + encodeURIComponent(q) + '*&section_id=predictive-results';
    fetch(url, { signal: controller.signal })
      .then(function (r) { return r.text(); })
      .then(function (html) { resultsEl.innerHTML = html; })
      .catch(function (e) { if (e.name !== 'AbortError') resultsEl.innerHTML = ''; });
  }

  function openSearch() {
    clearTimeout(closeTimer);
    lastFocus = document.activeElement;
    // 1) Turn the header solid white first (it sits above the panel via z-index).
    if (headerEl) headerEl.classList.add('search-open');
    // Measure the header height AFTER .search-open is applied. On transparent (hero) pages
    // that class swaps the compact light logo for the dark full-wordmark logo, which has a
    // different height — so the header resizes at this moment. Measuring after the swap keeps
    // the panel flush against the header (otherwise a strip of hero shows through the gap).
    positionBelowHeader();
    if (overlay) overlay.classList.add('is-visible');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    openers.forEach(function (o) { o.setAttribute('aria-expanded', 'true'); });
    // 2) Once the header has gone white, slide the panel out from behind it.
    openTimer = setTimeout(function () {
      modal.classList.add('is-open');
      input.focus();
    }, 320);
  }

  function closeSearch() {
    clearTimeout(openTimer);
    // 1) Retract the panel behind the (still white) header.
    modal.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-visible');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    openers.forEach(function (o) { o.setAttribute('aria-expanded', 'false'); });
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    // 2) Only after the panel is fully hidden, let the header revert.
    closeTimer = setTimeout(function () {
      if (!modal.classList.contains('is-open') && headerEl) headerEl.classList.remove('search-open');
    }, 480);
  }

  openers.forEach(function (o) { o.addEventListener('click', openSearch); });
  if (closeBtn) closeBtn.addEventListener('click', closeSearch);
  if (overlay) overlay.addEventListener('click', closeSearch);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeSearch();
  });

  input.addEventListener('input', function () {
    var q = input.value.trim();
    if (clearBtn) clearBtn.hidden = q === '';
    if (!predictive) return;
    clearTimeout(debounceTimer);
    if (q.length < 2) { resultsEl.innerHTML = ''; return; }
    debounceTimer = setTimeout(function () { suggest(q); }, 250);
  });

  if (clearBtn) clearBtn.addEventListener('click', function () {
    input.value = '';
    clearBtn.hidden = true;
    resultsEl.innerHTML = '';
    input.focus();
  });

  document.addEventListener('search-modal:open', openSearch);
})();

/* Partial-word search (fazyo-style): Shopify's standard search only prefix-matches with a
   trailing "*" (options[prefix]=last does NOT work on this store). Append "*" to the query
   on every search-form submit so "si" → "side" etc., while keeping the standard engine
   (filters / sort / pagination). Displayed terms strip the "*" in the Liquid. */
(function () {
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.querySelector) return;
    var input = form.querySelector('input[name="q"]');
    if (!input) return;
    var v = (input.value || '').trim();
    // Reject a blank search: don't submit an empty query (no /search?q= landing page).
    if (!v) { e.preventDefault(); return; }
    if (v.charAt(v.length - 1) !== '*') {
      input.value = v + '*';
      // The GET form has already serialized "v*" for the request by the time this
      // handler returns, so restore the visible text — the customer should never
      // see the trailing "*" in the field (flash before nav, or via bfcache on back).
      setTimeout(function () { input.value = v; }, 0);
    }
  }, true);
})();
